export const theme = {
  // shopify brand colors
  stone50: '#fdfdfd',
  stone800: '#2b2b2b',
  emerald600: '#008445',
  // text font
  textBlack: '#212121',
  // Brand Colors (new to system)
  primary: '#2F711C',
  darkestGreen: '#1a1c16',
  darkGreen: '#23350d',
  cream: '#fffbf0',
  backgroundGreen: '#eef1e6',
  darkOrange: '#8f0000',
  orange: '#b93e09',
  yellow: '#ffae00',
  darkBlue: '#001f49',
  cerulean: '#24A2FF',
// Current Fonts In Use
  treeGreen: '#2F711C',
  secondary: '#7fba00',
  gray85: '#D9D9D9',
  white: '#fff', // do not use as text on white background
  darkGrey: '#545454',
  starColor: '#60A000',
// colors that are staying
  mediumGrey: '#9b9d9d', // do not use as text on white background
  darkGreyv2: '#a9a9a9',
  gray65: '#A6A6A6',
  lightGreen: '#ddebb4', // do not use as text on white background
  indiaGreen: '#2f8e00',
  brandedLtGreen: '#57A445',
  tuskGreen: '#CEE4B5',
  prairieGreen: '#57A300',
  lightPeach: '#FBE6CF',
  stoneGrey: '#717663',
  spanishGreen: '#00833D',
  silver: '#C0C0C0',
  panache: '#EEF6E5',
  lightGrey: '#fafafa', // do not use as text on white background
  platinumGrey: '#E6E6E6',
  disableGrey: '#6D6D6D',
  sageGreen: '#B4BAA2',
  paleSage: '#E3E8D4',
  mistyOlive: '#F1F3E9',
  peachFuzz: '#F7C9A1',
  lightPeachFuzz: '#D37549',
  borderRadius: {
    xs: '2px',
    sm: '4px',
    s: '5px',
    md: '6px',
    lg: '8px',
    xl: '10px',
    full: '50%',
  },
  fontFamily: {
    body: 'Futura PT',
  },
  fontSize: {
    xxs: '12px',
    xs: '14px',
    s: '15px',
    normal: '16px',
    sm: '18px',
    base: '20px',
    md: '22px',
    lg: '24px',
    xl: '26px',
    '2xl': '28px',
  },
  fontWeight: {
    thin: 100,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },
  lineHeight: {
    leading2: '10px',
    leading3: '12px',
    leading4: '16px',
    leading5: '20px',
    leading6: '22px',
    leading7: '24px',
    leading75: '28px',
    leading8: '32px',
    leading9: '36px',
    leading10: '40px',
    leadingNone: '1',
  },
  transition: {
    linkHover: 'color 0.15s linear',
    blockLinkHover: 'all 0.15s linear',
  },
  breakpoints: {
    xs: '360px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    '2xl': '1420px',
    mobile: '767px',
    tablet: '1023px',
    desktop: '1024px',
  },
}
